import { OrderStepper } from "./OrderStepper";

// ─── Props ───────────────────────────────────────────────────────────────────
interface WizadProps {
  availableSegments: string[];
  activeStep: number;
  totalSteps: number;
  completedSteps: Set<number>;
  /** Ano do ciclo exibido no cabeçalho ("Etapa X de Y · Ciclo {cycleYear}") */
  cycleYear?: string | number;
  goToPrevious: () => void;
  goToNext: () => void;
  goToStep: (stepIndex: number) => void;
}

/**
 * Wizad — adaptador sobre OrderStepper.
 *
 * Constrói o array de steps a partir de availableSegments + "Professor" + "Resumo"
 * e delega toda a renderização ao OrderStepper.
 */
export const Wizad = ({
  availableSegments,
  activeStep,
  totalSteps,
  completedSteps,
  cycleYear,
  goToPrevious,
  goToNext,
  goToStep,
}: WizadProps) => {
  const steps = [
    ...availableSegments.map((seg) => ({ label: `${seg} - Aluno`, variant: "default" as const })),
    { label: "Professor", variant: "professor" as const },
    { label: "Resumo",    variant: "resumo"    as const },
  ];

  return (
    <OrderStepper
      activeStep={activeStep}
      totalSteps={totalSteps}
      completedSteps={completedSteps}
      steps={steps}
      cycleYear={cycleYear}
      goToPrevious={goToPrevious}
      goToNext={goToNext}
      goToStep={goToStep}
    />
  );
};